import { Component, effect, inject, input, output, ChangeDetectionStrategy } from '@angular/core'
import { CategoryTreeType } from '../../models'
import { DndDropEvent } from 'ngx-drag-drop'
import { Category } from 'depoto-core/src/entities'
import { CoreService } from '../../services'
import { SchemaUtil } from '../../utils'
import { TranslateService } from '@ngx-translate/core'
import { injectQuery } from '@tanstack/angular-query-experimental'
import { CategoryService } from '../../services/entity-services/category.service'

@Component({
  selector: 'category-tree',
  templateUrl: './category-tree.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CategoryTreeComponent {
  private categoryService = inject(CategoryService)

  type = input<CategoryTreeType>()
  editedCategory = input<Category | Partial<Category>>()
  selectedCategories = input<Category[]>()

  selectedCategoriesChange = output<any>()
  editedCategoryChange = output<any>()

  categoryTreeLabel = input<string>()
  categories = input<Category[]>([])
  mainCategory = input<Category>()

  mainCategoryChange = output<Category>()

  isInBulkEdits = input<boolean>(false)
  isForFilterCategories = input<boolean>(false)

  categoriesChange = output<any>()

  // Loading state mirrors the query's fetching state to avoid a permanent overlay blocking clicks
  get loading(): boolean {
    return this.queryCategoriesOptions.isFetching()
  }
  public categoryTreeTypeEnum = CategoryTreeType

  readonly queryCategoriesOptions = injectQuery(() => ({
    queryKey: ['categories', 'options'],
    queryFn: async () => {
      if (!this.type()) {
        alert(this.translateService.instant('category-tree.unknown'))
      }
      return await this.categoryService
        .getCategories({ sort: 'name', direction: 'ASC', filters: { hasParent: false } }, SchemaUtil.category)
        .then(result => result.items)
    },
  }))

  constructor(
    private core: CoreService,
    private translateService: TranslateService
  ) {
    effect(() => {
      this.queryCategoriesOptions.data()
    })
  }

  categoriesChanged(event) {
    this.selectedCategoriesChange.emit(event)
  }

  mainCategoryValueChanged(event) {
    this.mainCategoryChange.emit(event)
  }

  editedCategoryChanged(event) {
    this.editedCategoryChange.emit(event)
  }

  public async onDrop(event: DndDropEvent, list: Category[]) {
    if (list) {
      let index = event.index
      if (typeof index === 'undefined') {
        index = list.length
      }
      const droppedCategory: Category = event.data
      list.splice(index, 0, droppedCategory)
      droppedCategory.position = index - 1 > 0 ? index - 1 : 0 // todo server, fe is fine
      droppedCategory.parent = null
      await this.core.services.category.update(droppedCategory)
    }
  }

  public onDragMove(item: Category, list: Category[]) {
    const index = list.indexOf(item)
    list.splice(index, 1)
  }
}
